export type HttpErrorResponse = { status?: number; data?: unknown } | null | undefined;

const SESSION_REVOKED = 'SESSION_REVOKED';
const AUTH_FAILURE_CODE = 401;
const FORBIDDEN_STATUS = 403;

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

/**
 * i2c_v2 serializes JWT failures as HTTP 403 with `code: 401` (and `data.error: 401`) in the body;
 * a revoked session also carries `errorKey: 'SESSION_REVOKED'`.
 */
function isAuthFailureBody(body: unknown): boolean {
  if (!isRecord(body)) return false;

  const data = isRecord(body.data) ? body.data : undefined;

  return body.code === AUTH_FAILURE_CODE || data?.error === AUTH_FAILURE_CODE || body.errorKey === SESSION_REVOKED || data?.errorKey === SESSION_REVOKED;
}

function isForbiddenResponse(response: HttpErrorResponse): boolean {
  return response?.status === FORBIDDEN_STATUS;
}

export function isAuthFailureResponse(response: HttpErrorResponse): boolean {
  return isForbiddenResponse(response) && isAuthFailureBody(response?.data);
}

function isNonAuthForbiddenResponse(response: HttpErrorResponse): boolean {
  return isForbiddenResponse(response) && !isAuthFailureResponse(response);
}

/**
 * A 403 rejected before reaching the backend (edge WAF): its body is HTML, plain text or empty,
 * never the JSON object the backend returns for its own permission or license errors.
 */
export function isEdgeBlockedResponse(response: HttpErrorResponse): boolean {
  return isNonAuthForbiddenResponse(response) && !isRecord(response?.data);
}
